'use strict';

import controller from './contrato.controller';
import template from './contrato.html';

const ContratoComponent = {
  bindings: {
    proyecto: '=',
    modoVista: '<'
  },
  controller,
  template
};

export default ContratoComponent;



// WEBPACK FOOTER //
// ./src/app/components/proyectos/c-proyectos/contrato/contrato.component.js